import { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import classnames from 'classnames';
import { useHistory } from 'react-router-dom';
import enviroment from '../../../enviroments/enviroment';
import { AppContext } from '../../../commons/context/App-context';
import { EPassword, EErrorMsg } from '../../../commons/statics/controls';
import Recaptcha from '../../../commons/components/recaptcha/Recaptcha';
import './recover-password.scss';

interface IForgotPassword {
    password: string;
    rePassword: string;
}

const RecoverPassword = () => {
    const history = useHistory();
    const { register, handleSubmit, formState, getValues } = useForm({
        mode: 'onChange',
    });
    const { errors, isDirty, isValid } = formState;
    const { isLoading, changeIsLoading } = useContext(AppContext);
    const [msgError, setMsgError] = useState<string>('');

    const handleOnSubmit = (u: IForgotPassword) => {
        const { password, rePassword } = u;
        const params = new URLSearchParams(window.location.search);
        const hash = params.get('hash') || '';

        changeIsLoading(true);
        setMsgError('');
        if (password && rePassword) {
            if (password === rePassword) {
                axios
                    .post(enviroment.apiURL + '/user/change_password', {
                        password,
                        hash,
                    })
                    .then((res: any) => {
                        const { err } = res?.data || {};

                        changeIsLoading(false);
                        if (err) {
                            setMsgError(err);
                        } else {
                            history.push('/recover-password');
                        }
                    })
                    .catch(() => {
                        changeIsLoading(false);
                        setMsgError(EErrorMsg.generic);
                    });
            } else {
                changeIsLoading(false);
                setMsgError(EErrorMsg.confirmPassword);
            }
        } else {
            changeIsLoading(false);
            setMsgError(EErrorMsg.dataForm);
        }
    };

    const handleBackLanding = () => {
        window.open('https://rpp.pe/empresasquetransforman', '_self');
    };

    return (
        <Recaptcha>
            <div className="RecoverPasswordWrapFull">
                <div className="RecoverPasswordLogo">
                    <img
                        alt="Empresas que transforman el Perú"
                        src="/images/logo.png"
                        onClick={handleBackLanding}
                    />
                </div>
                <div className="RecoverPasswordWrap">
                    <div className="RecoverPasswordWrapInner">
                        <h4 className="RecoverPasswordTitle">
                            Ingresa tu nueva contraseña
                        </h4>
                        <form
                            onSubmit={handleSubmit(handleOnSubmit)}
                            className="RecoverPasswordWrapForm"
                        >
                            <div className="mbm">
                                <label
                                    className={classnames({
                                        label: true,
                                        invalid: errors.password,
                                    })}
                                    htmlFor="password"
                                >
                                    Contraseña
                                </label>
                                <input
                                    className={classnames({
                                        input: true,
                                        invalid: errors.password,
                                    })}
                                    id="password"
                                    type="password"
                                    placeholder="Ingresa tu contraseña"
                                    maxLength={EPassword.maxLength}
                                    {...register('password', {
                                        required: {
                                            value: true,
                                            message: 'Contraseña es requerida.',
                                        },
                                        minLength: {
                                            value: EPassword.minLength,
                                            message:
                                                'Min. ' +
                                                EPassword.minLength +
                                                ' caracteres.',
                                        },
                                        maxLength: {
                                            value: EPassword.maxLength,
                                            message:
                                                'Max. ' +
                                                EPassword.maxLength +
                                                ' caracteres.',
                                        },
                                    })}
                                />
                                <div className="helpText invalid">
                                    {errors?.password &&
                                        errors?.password?.message}
                                </div>
                            </div>
                            <div className="mb1">
                                <label
                                    className={classnames({
                                        label: true,
                                        invalid: errors.rePassword,
                                    })}
                                    htmlFor="rePassword"
                                >
                                    Confirma tu contraseña
                                </label>
                                <input
                                    className={classnames({
                                        input: true,
                                        invalid: errors.rePassword,
                                    })}
                                    id="rePassword"
                                    type="password"
                                    placeholder="Ingresa tu contraseña nuevamente"
                                    maxLength={EPassword.maxLength}
                                    {...register('rePassword', {
                                        required: {
                                            value: true,
                                            message:
                                                'Confirma tu contraseña es requerida.',
                                        },
                                        minLength: {
                                            value: EPassword.minLength,
                                            message:
                                                'Min. ' +
                                                EPassword.minLength +
                                                ' caracteres.',
                                        },
                                        maxLength: {
                                            value: EPassword.maxLength,
                                            message:
                                                'Max. ' +
                                                EPassword.maxLength +
                                                ' caracteres.',
                                        },
                                        validate: (val) =>
                                            val === getValues('password') ||
                                            EErrorMsg.confirmPassword,
                                    })}
                                />
                                <div className="helpText invalid">
                                    {errors?.rePassword &&
                                        errors?.rePassword?.message}
                                </div>
                            </div>
                            <div className="mb1">
                                <button
                                    className="button buttonFull"
                                    type="submit"
                                    disabled={isLoading || !isDirty || !isValid}
                                >
                                    Restablecer contraseña
                                </button>
                            </div>
                            {msgError && (
                                <div className="mb1 helpText invalid">
                                    {msgError}
                                </div>
                            )}
                        </form>
                    </div>
                </div>
            </div>
        </Recaptcha>
    );
};

export default RecoverPassword;
